import type { UserConfig } from "./interfaces/calculator"
import type { Period, PlanName } from "./interfaces/pricing"

interface MakeConfigLoadedUrlParams {
  userConfig?: UserConfig | string | undefined // string is for stringified userconfig
  plan?: PlanName | undefined
  period?: Period | undefined
  baseUrl: string
}

export default function makeConfigLoadedUrl({ userConfig, plan, period, baseUrl }: MakeConfigLoadedUrlParams) {

  const url = new URL(baseUrl)

  if(plan) url.searchParams.set('plan', plan)
  if(period) url.searchParams.set('period', period)
  if(userConfig) url.searchParams.set('userConfig', typeof userConfig === 'string' ? userConfig : JSON.stringify(userConfig))

  return url.toString()

}